import { render, staticRenderFns } from "./ShopDashboard.vue?vue&type=template&id=f0e79550"
import script from "./ShopDashboard.vue?vue&type=script&lang=js"
export * from "./ShopDashboard.vue?vue&type=script&lang=js"
import style0 from "./ShopDashboard.vue?vue&type=style&index=0&id=f0e79550&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports